import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import { useTabState as useReakitTabState, Tab as ReakitTab, TabList as ReakitTabList, TabPanel as ReakitTabPanel } from 'reakit/Tab';
import classes from '@nerdwallet/base-styles/classes';
import analytics from '@nerdwallet/analytics'; // TODO: add types
// @ts-expect-error - no types yet

import { ImpressionContext } from '@nerdwallet/analytics/react/impression'; // @ts-expect-error - no types yet

import { elementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import { useId } from '@nerdwallet/react-accessibility';
import { Title } from '../Title/Title';
import styles from './Tabs.module.less';

/**
 * This hook is a wrapper around Reakit's own `useTabState` hook that provides
 * additionally functionality:
 *
 * It exposes APIs for accessing and setting the selected tab in terms of its
 * index in the `tabs` array, instead of just its ID. This API is intended to be more ergonomic
 *
 * It allows the user to specify an initially selected tab in terms of its index.
 *
 * It generates IDs for tabs; this makes the component easier to use for
 * developers, as they don't have to specify their own unique IDs for tabs.
 */
export var useTabState = function useTabState(props) {
  var tabs = props.tabs,
      baseIdProp = props.baseId,
      defaultTabId = props.defaultTabId,
      _props$defaultTabInde = props.defaultTabIndex,
      defaultTabIndex = _props$defaultTabInde === void 0 ? 0 : _props$defaultTabInde,
      initialState = _objectWithoutProperties(props, ["tabs", "baseId", "defaultTabId", "defaultTabIndex"]);

  var baseId = useId(baseIdProp); // Internally, Reakit uses IDs to refer to props. However, we want this
  // component's API to deal in indices externally. So, we'll build up an
  // internal mapping from indices to IDs, and use this later when mapping
  // between internal and external tabs.
  //
  // We use `useMemo` so that the caller can opt into more efficient rendering
  // if they ensure consistent identity of their `tabs` prop array.

  var tabIds = React.useMemo(function () {
    return tabs.map(function (tab, tabIndex) {
      return tab.id || "".concat(baseId, "-").concat(tabIndex);
    });
  }, [tabs, baseId]); // Compute a reverse mapping from IDs to indices.

  var tabIndices = React.useMemo(function () {
    return tabIds.reduce(function (acc, tabId, index) {
      acc[tabId] = index;
      return acc;
    }, {});
  }, [tabIds]); // Allow default tab to be specified with either ID or index

  var selectedId = defaultTabId || tabIds[defaultTabIndex];
  var tabState = useReakitTabState(_objectSpread(_objectSpread({}, initialState), {}, {
    baseId: baseId,
    // Note: changes to this value will not be reflected after the first
    // render. To change the selected tab, use the `setSelectedId` or
    // `setSelectedIndex` functions returned from this hook.
    selectedId: selectedId,
    // Ensures the the up/down arrow keys scroll the page instead of switching
    // between tabs.
    orientation: 'horizontal'
  })); // Expose the current selected tab by index
  // We provide `selectedId` to `useReakitTabState`, so it should always be defined
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

  var selectedIndex = tabIndices[tabState.selectedId]; // Expose an API for setting the current selected tab by index

  var setSelectedId = tabState.setSelectedId;
  var setSelectedIndex = React.useCallback(function (index) {
    return setSelectedId(tabIds[index]);
  }, [tabIds, setSelectedId]);
  return _objectSpread(_objectSpread({}, tabState), {}, {
    tabs: tabs,
    tabIds: tabIds,
    tabIndices: tabIndices,
    selectedIndex: selectedIndex,
    setSelectedIndex: setSelectedIndex
  });
};

/**
 * Component that animates (fades) in its child when its visibility changes.
 * The child is left in the DOM when it's not visible, but it's hidden with
 * `display: none`. This ensures that screen readers won't read its content
 * and that the content won't be accessible via the keyboard.
 *
 * The component is not "animated out" - it is hidden immediately when
 * visibility is toggled off.
 */
var AnimateOpacity = function AnimateOpacity(_ref) {
  var _classNames;

  var children = _ref.children,
      visible = _ref.visible;

  // CSS transitions aren't applied during a transition to/from `display: none`.
  // So, to animate an appearance of a component, we need to first change from
  // `display: none` to `display: block`, but leave the opacity at 0. After we
  // flush that change to the DOM, we can then set the opacity to 1 so that it
  // fades in.
  var _React$useState = React.useState(visible),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isIn = _React$useState2[0],
      setIsIn = _React$useState2[1];

  React.useLayoutEffect(function () {
    setIsIn(visible);
  }, [visible]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.animateOpacity, (_classNames = {}, _defineProperty(_classNames, styles.animateOpacityVisible, visible), _defineProperty(_classNames, styles.animateOpacityIn, isIn), _classNames))
  }, children);
};

export var ControlledTabs = function ControlledTabs(props) {
  var _reakitTabState$items, _reakitTabState$items2, _reakitTabState$items3, _props$tracking3, _props$tracking4;

  var _props$hasSpacingBetw = props.hasSpacingBetweenTabsAndContent,
      hasSpacingBetweenTabsAndContent = _props$hasSpacingBetw === void 0 ? true : _props$hasSpacingBetw,
      ariaLabel = props['aria-label'],
      ariaLabelledBy = props['aria-labelledby']; // To avoid extraneous properties from ending up in the DOM, we'll destructure
  // the tab state into "our" state properties and Reakit's state properties.
  // With this, `reakitTabState` should have exactly the same properties as
  // the return value of Reakit's `useTabState` hook.

  var _props$tabState = props.tabState,
      tabs = _props$tabState.tabs,
      tabIds = _props$tabState.tabIds,
      tabIndices = _props$tabState.tabIndices,
      selectedIndex = _props$tabState.selectedIndex,
      setSelectedIndex = _props$tabState.setSelectedIndex,
      reakitTabState = _objectWithoutProperties(_props$tabState, ["tabs", "tabIds", "tabIndices", "selectedIndex", "setSelectedIndex"]); // Get impressionId from parent impression


  var impressionContext = React.useContext(ImpressionContext);
  var parentImpressionId = impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId; // Scroll the selected tab into view when it changes

  var selectedItemRef = (_reakitTabState$items = reakitTabState.items) === null || _reakitTabState$items === void 0 ? void 0 : (_reakitTabState$items2 = _reakitTabState$items[selectedIndex]) === null || _reakitTabState$items2 === void 0 ? void 0 : (_reakitTabState$items3 = _reakitTabState$items2.ref) === null || _reakitTabState$items3 === void 0 ? void 0 : _reakitTabState$items3.current;
  var previousSelectedIndexForScrolling = React.useRef(selectedIndex); // Scroll the tab bar on selectedItemRef mount

  var tabListContainerRef = React.useRef(null);
  var hasScrolledOnMount = React.useRef(false);
  React.useEffect(function () {
    var _selectedItemRef$scro;

    if (selectedIndex === previousSelectedIndexForScrolling.current) return;
    selectedItemRef === null || selectedItemRef === void 0 ? void 0 : (_selectedItemRef$scro = selectedItemRef.scrollIntoView) === null || _selectedItemRef$scro === void 0 ? void 0 : _selectedItemRef$scro.call(selectedItemRef, {
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
    previousSelectedIndexForScrolling.current = selectedIndex;
  }, [selectedItemRef, selectedIndex]); // Only scroll tabs bar once on first render after tabs exist

  React.useEffect(function () {
    if (!hasScrolledOnMount.current && selectedItemRef && tabListContainerRef.current) {
      // Calculate scroll amount
      var _selectedItemRef$getB = selectedItemRef.getBoundingClientRect(),
          selectedTabWidth = _selectedItemRef$getB.width,
          selectedTabLeft = _selectedItemRef$getB.left;

      var _tabListContainerRef$ = tabListContainerRef.current.getBoundingClientRect(),
          tabContainerWidth = _tabListContainerRef$.width,
          tabContainerX = _tabListContainerRef$.x; // Scrolling the tab to the middle of the container


      var tabScrollOffset = (tabContainerWidth + tabContainerX - selectedTabWidth) / 2;
      tabListContainerRef.current.scrollLeft = selectedTabLeft - tabScrollOffset;
      hasScrolledOnMount.current = true;
    }
  }); // Analytics event instrumentation. The semantics used to be "fire event when a
  // tab is clicked", but now that tabs can be changed via the keyboard without
  // clicking, this event will be fired whenever the selected tab is changed.
  // This is a subtle difference and it's worth noting.

  var previousSelectedIndexForTracking = React.useRef(selectedIndex);
  React.useEffect(function () {
    var _props$tracking;

    // Storing the previous index in a ref allows us to avoid firing an event
    // on the initial render, as the "previous" index will match the "current"
    // index because of how this ref is initialized.
    if ((_props$tracking = props.tracking) !== null && _props$tracking !== void 0 && _props$tracking.enabled && previousSelectedIndexForTracking.current !== selectedIndex) {
      var _props$tracking2;

      var tab = tabs[selectedIndex];

      var _ref2 = (tab === null || tab === void 0 ? void 0 : tab.trackingProps) || {},
          _ref2$action = _ref2.action,
          action = _ref2$action === void 0 ? 'select' : _ref2$action,
          entityName = _ref2.entityName,
          _ref2$interactionType = _ref2.interactionType,
          interactionType = _ref2$interactionType === void 0 ? 'press' : _ref2$interactionType,
          otherTrackingProps = _objectWithoutProperties(_ref2, ["action", "entityName", "interactionType"]); // Fire Bedrock event


      if (entityName) {
        var elementInteractedPayload = {
          action: action,
          entity_name: entityName,
          interaction_type: interactionType,
          impression_id: parentImpressionId
        };
        analytics.track('element_interacted', elementInteractedPayload);
      } // Fire Legacy event


      elementInteraction(_objectSpread({
        interactionType: 'CLICK',
        sectionCategory: (_props$tracking2 = props.tracking) === null || _props$tracking2 === void 0 ? void 0 : _props$tracking2.sectionCategory,
        elementContent: tab.label,
        elementName: 'tab',
        elementPosition: selectedIndex
      }, otherTrackingProps));
      previousSelectedIndexForTracking.current = selectedIndex;
    }
  }, [selectedIndex, tabs, (_props$tracking3 = props.tracking) === null || _props$tracking3 === void 0 ? void 0 : _props$tracking3.enabled, (_props$tracking4 = props.tracking) === null || _props$tracking4 === void 0 ? void 0 : _props$tracking4.sectionCategory, parentImpressionId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: tabListContainerRef,
    className: styles.tabListContainer
  }, /*#__PURE__*/React.createElement(ReakitTabList, _extends({}, reakitTabState, {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    className: classNames(styles.tabList, _defineProperty({}, classes('margin-bottom-3'), hasSpacingBetweenTabsAndContent))
  }), tabs.map(function (tab, tabIndex) {
    var tabId = tabIds[tabIndex];
    return /*#__PURE__*/React.createElement(ReakitTab, _extends({}, reakitTabState, {
      className: styles.tab,
      id: tabId,
      key: tabId
    }), /*#__PURE__*/React.createElement(Title, {
      size: "x-small",
      component: "span",
      className: styles.tabLabel
    }, tab.label), /*#__PURE__*/React.createElement("div", {
      className: styles.matchParentSize
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.tabUnderline, styles.tabUnderlineHover)
    }), /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.tabUnderline, styles.tabUnderlineSelected)
    }), /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.matchParentSize, styles.tabFocus)
    })));
  }))), tabs.map(function (tab, tabIndex) {
    var tabId = tabIds[tabIndex];
    var tabSelected = reakitTabState.selectedId === tabId;
    return /*#__PURE__*/React.createElement(ReakitTabPanel, _extends({}, reakitTabState, {
      id: "".concat(tabId, "-panel"),
      tabId: tabId,
      key: tabId // The tab panel can receive focus - ensure that a focus ring is shown for it.
      ,
      className: classes('focus-ring')
    }), /*#__PURE__*/React.createElement(AnimateOpacity, {
      visible: tabSelected
    }, tab.content));
  }));
};
export var Tabs = function Tabs(_ref3) {
  var baseId = _ref3.baseId,
      defaultTabId = _ref3.defaultTabId,
      defaultTabIndex = _ref3.defaultTabIndex,
      tabs = _ref3.tabs,
      restProps = _objectWithoutProperties(_ref3, ["baseId", "defaultTabId", "defaultTabIndex", "tabs"]);

  var tabState = useTabState({
    baseId: baseId,
    defaultTabId: defaultTabId,
    defaultTabIndex: defaultTabIndex,
    tabs: tabs
  });
  return /*#__PURE__*/React.createElement(ControlledTabs, _extends({
    tabState: tabState
  }, restProps));
};